/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UssdLoanApplicationOutputDto { 
    principalAmount?: string | null;
    interestAmount?: string | null;
    tenure?: number;
    tenurePeriodType?: string | null;
    currency?: string | null;
    loanApplied?: boolean;
    responseMessage?: string | null;
}

